<template>
	<v-sheet color="transparent">
		<h2 class="cn-font grey--text">Kontakt</h2>
		<p class="mt-2">Über dieses Formular steht Ihnen das CheckIT-NOW Team zur Verfügung. Wir freuen uns auf Ihre Fragen, Kommentare und Anregungen!</p>
		<ContactForm></ContactForm>
		<p>
			<BackButton></BackButton>
		</p>
	</v-sheet>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	import BackButton from "@/components/elements/BackButton"
	import ContactForm from '@/components/forms/ContactForm.vue'
	export default {
		name: "Contact", 
		props: {
			
		},
		data: () => {
			return {

			}
		},
		components: {
			BackButton,
			ContactForm
		},
		// computed: {
			// ...Vuex.mapState({})
		// },
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>